// import React, { useRef } from "react";

// import { useNavigate } from "react-router-dom";

// import "../../index.css";

// export default function ForgotPass({
//   onRouteChange,
//   isSignedIn,
//   props,
//   executeScroll,
//   executeScroll2,
//   executeScroll3,
//   executeScroll4,
//   executeScroll5,
//   executeScroll6,
// }) {
//   const navigate = useNavigate();

//   return (
//     <div className="forgotpass">
//       <div className="forgotpass__box">
//         <div className="forgotpass__header ">
//           <img
//             src="img/WHITE LOGO.png"
//             alt="terraweb white logo"
//             className="forgotpass__header--image"
//           />
//         </div>
//         <button className="reset__btn ">
//           <label className="resetlabel black b f3 w-100">
//             You will recieve an email to reset your password if your email is in
//             our database
//           </label>
//         </button>
//         <div className="forgotpass__main">
//           <input
//             type="email"
//             placeholder="email"
//             id="emailforgot"
//             className="forgotpass__inputpass"
//           />

//           <div className="forgotpass__btns">
//             <button className="btn btn-white">
//               <label className="link-white">Reset</label>
//             </button>
//             <button className="btn btn-orange sign_in">
//               <label
//                 onClick={() => navigate("/register")}
//                 className="link-orange"
//               >
//                 Sign In
//               </label>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";

export default function ForgotPass() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // success or error text
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!email) {
      setStatus("Please enter your email.");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const res = await fetch("https://api.terraweb.africa/forgotPass", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setStatus(data.error || "Error resetting your password. Contact support if issue persists.");
      } else {
        setStatus("Check your email for your new password.");
      }
    } catch (err) {
      setStatus("Server encountered an error. Try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="forgotpass">
      <div className="forgotpass__box">
        <div className="forgotpass__header ">
          <img
            src="img/WHITE LOGO.png"
            alt="terraweb white logo"
            className="forgotpass__header--image"
          />
        </div>

        <button className="reset__btn ">
          <label className="resetlabel black b f3 w-100">
            You will receive an email to reset your password if your email is in our database.
          </label>
        </button>

        <div className="forgotpass__main">
          <input
            type="email"
            placeholder="email"
            id="emailforgot"
            className="forgotpass__inputpass"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {status && <p className="status-text">{status}</p>}

          <div className="forgotpass__btns">
            <button className="btn btn-white f3" onClick={handleReset} disabled={loading}>
              <label className="link-white">{loading ? "Sending..." : "Reset"}</label>
            </button>

            <button className="btn btn-orange sign_in f3" onClick={() => navigate("/login")}>
              <label onClick={() => navigate("/login")} className="link-orange">
                Sign In
              </label>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
